<template>
    <div>
        <div class="container">
			<div style="margin-left: 12px;">
				<span>选择计费方式：</span>
				<el-radio v-model="freightType" @change='changeType' :label="0">按重量</el-radio>
				<el-radio v-model="freightType" @change='changeType' :label="2">按件数</el-radio>
				<el-button v-if="freightType === 0" type="text" size="mini" @click='goFreightClick'>去修改计费方式</el-button>
			</div>
			<div class="table-box">
				<div class="table-wrap">
					<div class="freight-table-head">
						<div class="flex-one">可配送区域<i class="el-icon-circle-plus-outline area-add" v-if="freightType === 2" @click="addClick"></i></div>
						<div class="flex-two">计费规则</div><div class="flex-three"></div>
					</div>
					<div class="freight-content-wrap">
						<div class="freight-table-content" v-for="(item, index) in areaTableData" :key="item.id">
							<div class="flex-one">
								<el-button v-if="freightType === 2" size='mini' @click="editTree(item,index)" style="padding:0 20px;line-height:20px;white-space:normal;" type='text' :title="item.areaname">{{item.showname}}</el-button>
								<span v-else>{{item.showname}}</span>
							</div>
							<div class="flex-two">
								<div v-if="freightType === 2">
									<div class="rule-box two-box">
										<div v-for="(childItem, childIndex) in item.freightPricingList" :key="childIndex" class="two-wrap">
											<div class="step-box">
												商品于
												<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>
												件（不含）~
												<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== item.freightPricingList.length-1" @change="stepMoneyChange(childIndex, index,'maxValue')"></el-input>
												件（不含），收
												<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 1}" type='number' v-model="childItem.freightMoney" @change="stepMoneyChange(childIndex, index,'freightMoney')"></el-input>
												元
											<el-button size='mini' v-if='childIndex === item.freightPricingList.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="addTimeClick(childItem.maxValue, index)"></el-button>
											<el-button size='mini' v-if='item.freightPricingList.length > 1 && childIndex === item.freightPricingList.length-1' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick(childIndex, index)"></el-button></div>
										</div>
									</div>
								</div>
								<div v-if="freightType === 0" style="line-height: 40px;padding: 0 5px;">
									商品于0kg（含）~
									<el-input size='mini' class="cell-input" type='number' :disabled="true" v-model="item.freightPricingList[0].maxValue"></el-input>
									kg（含），收
									<el-input size='mini' class="cell-input" type='number' :disabled="true" v-model="item.freightPricingList[0].freightMoney"></el-input>
									元，每增加
									<el-input size='mini' class="cell-input" type='number' :disabled="true" v-model="item.freightPricingList[0].stepValue"></el-input>
									kg，加收
									<el-input size='mini' class="cell-input" type='number' :disabled="true" v-model="item.freightPricingList[0].stepMoney"></el-input>
									元
								</div>
							</div>
							<div class="flex-three">
								<el-button size='mini' v-if="areaTableData.length > 1 && freightType === 2" style="padding:4px" icon="el-icon-minus" circle @click="deleteClick(item.id, index)"></el-button>
								<el-button size='mini' v-if="areaTableData.length - 1 === index && freightType === 2" style="padding:4px" icon="el-icon-plus" circle @click="addClick"></el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
            <el-dialog
                title="选择配送区域"
				append-to-body
                :visible.sync="showTree"
                class="dialog-title"
                width="800px"
                :close-on-click-modal="false">
                <tree @dialogClose="dialogClose" :disabled='freightType === 0' @addArea='addArea' :isCheckedArrHalf='checkedArrHalf' :isCheckedArr='checkedArr' :treeId='treeId' :isAdd='addTree' v-if="showTree"/>
            </el-dialog>
        </div>
		<div class="btn-feight-box">
			<el-button size='mini' class="fx-big-btn" plain @click="cancelClick">取消</el-button>
			<el-button size='small' class="fx-big-btn" plain type="primary" @click="submitForm">保存</el-button>
		</div>
    </div>
</template>

<script>
import tree from '@/components/freight/city.vue'
import { codeToCity } from '@/js/location/codeToCtiy.js'

export default {
	name: 'freight',
	components: {
		tree
	},
	props: {
		spceList: Array,
		orginData: Array,
		numOrginData: {
			type: Array,
			default: () => []
		},
		freightTypeOrgin: {
			type: Number,
			default: 0
		}
	},
	data () {
		return {
			provinceList: [
				'110000',
				'120000',
				'130000',
				'140000',
				'150000',
				'210000',
				'220000',
				'230000',
				'310000',
				'320000',
				'330000',
				'340000',
				'350000',
				'360000',
				'370000',
				'410000',
				'420000',
				'430000',
				'440000',
				'450000',
				'460000',
				'500000',
				'510000',
				'520000',
				'530000',
				'540000',
				'610000',
				'620000',
				'630000',
				'640000',
				'650000',
				'710000',
				'810000',
				'820000',
				'900000'
			],
			checkedArr: {},
			checkedArrHalf: {},
			isDisabled: true,
			isChanged: false,
			id: '',
			treeId: '',
			addTree: false,
			isAdd: false,
			showTree: false,
			areaTableData: [],
			freightType: 0,
			page: {
				size: 20,
				num: 1
			},
			productTableData: [],
			shopTableData: [],
			tableHeight: '100%',
			editIndex: null
		}
	},
	created () {
		this.freightType = this.freightTypeOrgin
		this.areaTableData = this.freightTypeOrgin === 0 ? this.orginData : this.numOrginData
	},
	methods: {
		goFreightClick () {
			this.$fxEventBus.$emit('setMenu', '2-4')
			this.$router.push('/main/freight')
		},
		cancelClick () {
			this.$emit('cancelFreight')
		},
		changeType (data) {
			this.isChanged = true
			if (this.freightType === 2) {
				this.areaTableData = this.numOrginData
			} else {
				this.areaTableData = this.orginData
			}
		},
		changeHandle () {
			this.isChanged = true
		},
		delTimeClick (index, Index) {
			this.areaTableData[Index].freightPricingList.splice(index, 1)
		},
		addTimeClick (value, Index) {
			let row = {
				minValue: value,
				maxValue: '',
				freightMoney: '',
				freightRatio: '',
				isError: -1
			}
			this.areaTableData[Index].freightPricingList.push(row)
		},
		checkSame (provinces) {
			let list = []
			let nameList = []
			this.areaTableData.forEach((item, index) => {
				if (item.provinces && index !== this.editIndex) {
					list = list.concat(item.provinces)
				}
			})
			provinces.forEach(item => {
				if (list.indexOf(item) !== -1) {
					nameList.push('【' + codeToCity[item] + '】')
				}
			})
			return	nameList
		},
		addArea (data) {
			let list = this.provinceList
			let checkArr = []
			let arr = []
			let flag = true
			let checkedArrHalf = []
			for (let i = 0; i < list.length; i++) {
				if (data.checkedArr[list[i]]) {
					if (data.checkedArr[list[i]].length > 0) {
						arr.push(list[i])
						flag = flag && false
					}
					checkArr = checkArr.concat(data.checkedArr[list[i]])
				}
				if (data.checkedArrHalf[list[i]]) {
					checkedArrHalf = checkedArrHalf.concat(data.checkedArrHalf[list[i]])
				}
			}
			if (flag) {
				this.$message.error('请选择配送区域')
				return false
			}
			let allArea = [...checkArr, ...checkedArrHalf]
			let allAreaName = allArea.map((item) => {
				return codeToCity[item]
			})
			let nameList = this.checkSame(data.provinces)
			if (nameList.length > 0) {
				this.$message.error('可配送区域' + nameList.join(',') + '已被添加')
				return false
			}
			if (this.addTree) {
				let row = {
					fixedMoney: '',
					freightPricingList: [{
						id: '',
						minValue: '0.00',
						maxValue: '',
						freightMoney: '',
						freightRatio: ''
					}],
					provinces: data.provinces,
					checkedArrHalf: data.checkedArrHalf,
					checkedArr: data.checkedArr,
					updateFullSelectedArea: checkArr,
					updateHalfSelectedArea: checkedArrHalf,
					minValue: '0.00',
					freightMoney: '',
					maxValue: '',
					stepValue: '',
					stepValstepMoneyue: '',
					isError: -1,
					areaname: allAreaName,
					showname: allAreaName.slice(0, 21).join(',') + '...'
				}
				this.areaTableData.push(row)
			} else {
				this.areaTableData[this.editIndex].provinces = data.provinces
				this.areaTableData[this.editIndex].areaname = allAreaName
				this.areaTableData[this.editIndex].showname = allAreaName.slice(0, 21).join(',') + '...'
				this.areaTableData[this.editIndex].checkedArrHalf = data.checkedArrHalf
				this.areaTableData[this.editIndex].checkedArr = data.checkedArr
				this.areaTableData[this.editIndex].updateFullSelectedArea = checkArr
				this.areaTableData[this.editIndex].updateHalfSelectedArea = checkedArrHalf
			}
			this.changeHandle()
			this.dialogClose()
		},
		dialogClose () {
			this.showTree = false
			this.addTree = false
		},
		submitForm () {
			return new Promise((resolve, reject) => {
				let error = 'error'
				if (this.areaTableData.length === 0) {
					this.$message.error('请指定一个配送区域！')
					reject(error)
					return false
				}
				let isError = false
				if (this.freightType === 2) {
					for (let index = 0; index < this.areaTableData.length; index++) {
						const item = this.areaTableData[index].freightPricingList
						for (let j = 0; j < item.length; j++) {
							const e = item[j]
							if (e.maxValue && +e.maxValue <= +e.minValue) {
								this.$message.error('请设置大于起始数量的数值！')
								reject(error)
								return false
							} else if (e.freightMoney === '' || e.freightMoney === null) {
								e.isError = 1
								isError = true
							} else {
								e.isError = -1
							}
						}
						if (isError) {
							this.$message.error('请输入计费规则！')
							reject(error)
							return false
						}
					}
				}
				let list = this.areaTableData
				list.forEach(item => {
					if (typeof (item.provinces) !== 'string') {
						item.provinces = item.provinces.join(',')
					}
					delete item.areaname
					item.freightPricingList.forEach(data => {
						data.freightRatio = 0
						data.stepValue = 0
						data.stepMoney = 0
					})
				})
				let params = {
					productAttrplanids: this.spceList.join(','),
					selfPickFlag: 0,
					stopFlag: 0,
					pricingType: 1,
					freightType: this.freightType,
					freightDetailDTOList: list
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/productattrplan/freight/detail/batch/save`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$emit('saveFreight')
						this.$message.success('保存成功')
						resolve('success')
					} else {
						this.$message.error(res.msg)
						reject(error)
					}
				})
			})
		},
		stepMoneyChange (index, Index, key) {
			let item = this.areaTableData[Index].freightPricingList[index][key]
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.areaTableData[Index].freightPricingList[index][key] = 0
			} else if (item > 9999999.99 && (key === 'freightstep')) {
				if (key === 'maxValue') {
					this.areaTableData[Index].freightPricingList[index][key] = '9999999'
				} else {
					this.areaTableData[Index].freightPricingList[index][key] = '9999999.99'
				}
			} else {
				if (key === 'maxValue') {
					this.areaTableData[Index].freightPricingList[index][key] = this.$fxUtils.toFixedSHW(item, 0)
				} else {
					this.areaTableData[Index].freightPricingList[index][key] = this.$fxUtils.toFixedSHW(item, 2)
				}
			}
			this.areaTableData[Index].freightPricingList[index].isError = -1
			this.changeHandle()
		},
		deleteClick (id, index) {
			this.$confirm('是否要删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/remove`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.areaTableData.splice(index, 1)
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		editTree (item, index) {
			this.treeId = item.id
			this.checkedArr = item.checkedArr
			this.checkedArrHalf = item.checkedArrHalf
			this.editIndex = index
			this.showTree = true
			this.addTree = false
		},
		addClick () {
			this.treeId = ''
			this.showTree = true
			this.addTree = true
			this.editIndex = null
		}
	}
}
</script>

<style  lang="stylus" scoped>
.goback{
    overflow :hidden
    span {
        float: left;
        display: inline-block;
        line-height: 75px;
        padding-right: 20px;
        i {
            border-radius: 50%
            border: 1px solid #2c3e50
            cursor: pointer
        }
    }
}
.container{
    overflow :auto;
    text-align :left;
    box-sizing :border-box;
    width :100%;
    padding-top :10px;
    height:calc(100% - 120px);
	font-size: 14px;
    .input-box{
        width:200px;
    }
	.btn-feight-box{
        margin 10px;
		display: flex;
		justify-content :center;
    }
    .table-box{
		flex: 1;
		min-height: 0;
        margin-top :10px;
		.table-wrap {
			height: 100%;
			overflow: hidden;
			overflow-y: auto;
			// display: flex;
			// flex-direction: column;
		}
        .freight-table-head {
			width: 100%;
			display: flex;
			height: 40px;
			line-height: 40px;
			.flex-one, .flex-two {
				text-align: center;
				height: 100%;
				background: #F7F7F7;
			}
		}
		.freight-content-wrap {
			// flex: 1;
			// overflow: hidden;
			// overflow-y: auto;
		}
		.freight-table-content {
			width: 100%;
			display: flex;
			// align-items: center;
			.flex-one {
				display: flex;
				align-items: center;
				justify-content: center;
				border-top: 0
			}
			.flex-two {
				padding: 10px 0;
				border-top: 0
			}
			.flex-three {
				display: flex;
				align-items: center;
				padding-left: 15px;
				box-sizing: border-box
			}
		}
		.flex-one {
			flex: 4;
			border: 1px solid #D5D5D5;
			box-sizing: border-box;
			border-right: 0
		}
		.flex-two {
			flex: 5;
			border: 1px solid #D5D5D5;
			box-sizing: border-box
		}
		.flex-three {
			width: 150px
		}
        .grid-content{
            box-sizing :border-box;
            height :100%;
            overflow-y :auto
        }
		.cell-input{
            width :120px;
			margin: 0 10px;
        }
		.rule-box {
			text-align: left;
			padding:0 5px
			.two-wrap:last-of-type {
				.step-box {
					margin-bottom: 0
				}
			}
			.step-box {
				line-height :40px;
				margin-bottom: 10px;
				.cell-input{
					width :100px;
					margin: 0 6px;
				}
			}
			.time-btn{
				padding:2px !important
				&:first-of-type {
					margin-left: 10px
				}
			}
		}
    }
    .time-box{
        width:300px;
        height :40px;
        line-height :40px;
        margin-left:80px;
    }
	.freight-type {
		display: flex
		align-items: center
		margin-top: 10px
		border-left: 4px solid var(--fx-primary-color);
		img {
			width: 25px;
			height: 25px
		}
		.type-title {
			font-size: 16px
			margin: 0 30px 0 10px;
		}
		.type-effect {
			color: var(--fx-primary-color);
			margin-left: 30px;
		}
	}
	.choose-text {
		margin: 15px 0 10px;
	}
	.type-text {
		color: #999;
		margin-left: 15px
	}
	.method-box {
		display: flex;
		width: 300px;
		height: 90px;
		border: 1px solid #eee;
		border-radius: 10px;
		padding: 15px 20px;
		box-sizing: border-box;
		color: #999;
		cursor: pointer;
		margin-right: 30px;
		img {
			width: 28px;
			height: 28px;
			margin-right: 10px;
		}
		.method-p {
			margin: 5px 0 10px;
			font-weight: bold;
		}
		.method-intro {
			font-size: 13px;
		}
		&.select {
			border: 1px solid #8EB5FF;
			background-color: #F7FAFE;
			.method-p {
				color: var(--fx-primary-color)
			}
		}
	}
	.area-add {
		margin-left: 5px;
		cursor: pointer;
		font-size: 16px;
		color: #999;
	}
	.tip-icon {
		display: inline-block;
		cursor: pointer;
		margin-left: 10px;
	}
}
</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
.flag-switch .el-switch__label {
	position: absolute;
	display: none;
	color: #fff;
}
.input-error .el-input__inner {
	border-color: #F56C6C;
}
/*打开时文字位置设置*/
.flag-switch .el-switch__label--right {
	z-index: 1;
	right: -7px;
}
/*关闭时文字位置设置*/
.flag-switch .el-switch__label--left {
	z-index: 1;
	left: 20px;
}
/*显示文字*/
.flag-switch .el-switch__label.is-active {
	display: block;
}
.flag-switch.el-switch .el-switch__core, .el-switch .el-switch__label {
	width: 40px !important;
}
.method-intro {
	.el-radio__label,.el-radio__input.is-checked+.el-radio__label {
		color: #333;
	}
}
.el-tooltip__popper.is-dark.tip-class {
	width: 250px
}
</style>
